// removed by extract-text-webpack-plugin
module.exports = {"eclipse":"#9e9fa5","wolf":"#dcdee2","small":"4px","medium":"8px","borderRadiusSmall":"3px","this":"ChevronBox__this___u454D","left":"ChevronBox__left___3CDjA","right":"ChevronBox__right___2O4Wh"};


//////////////////
// WEBPACK FOOTER
// ./src/components/styles/ChevronBox.css
// module id = 2384
// module chunks = 0 1